export function handleFilters() {
    $("body").on("click", ".js-toggle-filters", () => {
        $("body").toggleClass("show-filters");
        return false;
    }).on("click", ".js-open-filters, .js-show-filters", () => {
        $("body").addClass("show-filters");
        return false;
    }).on("click", ".js-close-filters, .js-hide-filters", () => {
        $("body").removeClass("show-filters");
        return false;
    });
}
